import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    DataTableFilterChipsDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap"
    }
});

export const useStyles = ({
    isSelectionBarActive,
    spaces
}: DataTableFilterChipsDynamicStyleType) => {
    const styles = {
        container: {
            marginTop: isSelectionBarActive ? 0 : -spaces.spacingSm,
            paddingHorizontal: spaces.spacingMd,
            paddingBottom: spaces.spacingMd,
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
